import { Button } from '@/common/ui/button'
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
} from '@/common/ui/dialog'
import { GetPlayerListTableData } from '@/modules/manage-player/type'
import { useState } from 'react'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import useMutationClearPlayerLockout from '@/modules/manage-player/api/hooks/useMutationClearPlayerLockout'
import { useQueryClient } from '@tanstack/react-query'
import { PlayerQueryKeys } from '@/modules/manage-player/keys'
import { Clock } from 'lucide-react'

interface PlayerClearLockoutModalProps {
	player: GetPlayerListTableData
}

export default function PlayerClearLockoutModal({
	player,
}: PlayerClearLockoutModalProps) {
	const [open, setOpen] = useState(false)

	const { mutate: clearLockout } = useMutationClearPlayerLockout()
	const queryClient = useQueryClient()

	const handleClearLockout = () => {
		try {
			clearLockout(
				{ phone: player.phone },
				{
					onSuccess: () => {
						toast.success('ปลดจำกัดเวลาผู้เล่นเรียบร้อยแล้ว')
						queryClient.invalidateQueries({
							queryKey: [PlayerQueryKeys.GetPlayerList],
						})
						setOpen(false)
					},
					onError: (error) => {
						showErrorToast(error)
					},
				},
			)
		} catch (error) {
			showErrorToast(error as Error)
		}
	}

	return (
		<>
			<Button
				variant="ghost"
				size="icon"
				onClick={() => setOpen(true)}
				title="ปลดจำกัดเวลา"
			>
				<Clock className="h-4 w-4" />
			</Button>

			<Dialog open={open} onOpenChange={setOpen}>
				<DialogContent className="sm:max-w-[425px]">
					<DialogHeader>
						<DialogTitle>ยืนยันการปลดจำกัดเวลา ({player.phone})</DialogTitle>
					</DialogHeader>

					<div className="pt-4">
						<p>คุณต้องการปลดจำกัดเวลาผู้เล่นนี้ใช่หรือไม่?</p>
						<p className="mt-2 text-sm text-muted-foreground">
							หมายเหตุ:
							การจำกัดเวลานี้เกิดขึ้นเมื่อผู้เล่นกรอกรหัสผ่านผิดเกินจำนวนที่กำหนด
						</p>
					</div>

					<div className="flex justify-end gap-4 pt-4">
						<Button
							variant="outline"
							onClick={() => setOpen(false)}
							type="button"
						>
							ยกเลิก
						</Button>
						<Button onClick={handleClearLockout} variant="destructive">
							ยืนยัน
						</Button>
					</div>
				</DialogContent>
			</Dialog>
		</>
	)
}
